/**************************************************
 * Nombre:       PremioPlan
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {FlagOutlined} from "@mui/icons-material";
import {obtenerPremio} from "../../../CodigoCliente/Puntos/obtenerPremio";
import {todos} from "../../../Constantes";
import {theme} from "../../../Tema";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const PremioAlcanzado = ({items = [], puntos}) => {
    const [premio, setPremio] = useState({});
    const {sCell} = useResponsive()


    useEffect(() => {
        setPremio(obtenerPremio({items: todos, puntos: puntos}));
    }, [puntos]);
    return (
        <Grid
            container
            justifyContent={'flex-end'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: '#fff',}}
        >

            <Grid container size={{xs: 8, sm: 8, md: 8}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-end'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 10, fontWeight: 500}}>Premio Alcanzado</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{fontSize: 14, fontWeight: 500}}>{premio ? premio.nombre : 'Ninguno'}</Typography>
                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                <FlagOutlined sx={{width: 36, height: 36, fill: theme.palette.primary.main}}/>
            </Grid>

        </Grid>
    )

}
export default PremioAlcanzado